import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import EApplicationComponent from '../components/e-application.component';
import { eApplicationSettings } from '../../../../../redux/e-applications-setting/action';
import { selectEApplicationSettingsQueryItems } from '../../../../../redux/e-applications-setting/selector';


const ManagementEApplicationsSettings = () => {
  const dispatch = useAppDispatch()
  const eApplicationSettingsQuery = useSelector(selectEApplicationSettingsQueryItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [selectEApplicationSettings, setSelectEApplicationSettings] = useState<any>([])

  const fetchEApplicationsSettingsQueryById = () => {
    dispatch(eApplicationSettings.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/e-applications/query`,
      entity: 'eApplications',
      jsonData: {
        Records: [
          {
            Id: 0
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectEApplicationSettings({ ...selectEApplicationSettings, [fields[0]]: value });
  }

  useEffect(
    () => {
      fetchEApplicationsSettingsQueryById()
      setIsLoading(false)
    }, []
  )

  useEffect(
    () => {
      if (isQuery) {
        setSelectEApplicationSettings(eApplicationSettingsQuery?.result?.items)
      }
    }, [isQuery]
  )

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    await dispatch(eApplicationSettings.resetAction({ actionType: 'update' }))
    await dispatch(eApplicationSettings.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/e-applications`,
      entity: 'eApplications',
      jsonData: {
        Records: [
          selectEApplicationSettings
        ]
      }
    }))
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <EApplicationComponent
          handleInnerFormChange={handleInnerFormChange}
          selectEApplicationSettings={selectEApplicationSettings}
          handleFormSubmit={handleFormSubmit}
        />
      }
    </>
  )
};

export default ManagementEApplicationsSettings;